import { render, staticRenderFns } from "./ProjectKPI.vue?vue&type=template&id=553983af&"
import script from "./ProjectKPI.vue?vue&type=script&lang=js&"
export * from "./ProjectKPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports